module.exports = __webpack_public_path__ + "static/00009.7ef82c96.jpg";